// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/products/ScrollableContainer.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/products/ScrollableContainer.tsx");
  import.meta.hot.lastModified = "1731877523863.602";
}
// REMIX HMR END

import React, { useRef, useEffect } from 'react';
export function ScrollableContainer({
  children
}) {
  _s();
  const spanRef = useRef(null);

  // kindly inspired from https://htmldom.dev/drag-to-scroll/
  let pos = {
    top: 0,
    left: 0,
    x: 0,
    y: 0
  };
  const mouseDownHandler = e => {
    const span = spanRef.current;
    pos = {
      left: span.scrollLeft,
      top: span.scrollTop,
      x: e.clientX,
      y: e.clientY
    };
    span.style.cursor = 'grabbing';
    span.style.userSelect = 'none';
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };
  const mouseMoveHandler = e => {
    const span = spanRef.current;
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;
    span.scrollTop = pos.top - dy;
    span.scrollLeft = pos.left - dx;
  };
  const mouseUpHandler = () => {
    const span = spanRef.current;
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
    span.style.cursor = 'grab';
    span.style.removeProperty('user-select');
  };
  const wheelHandler = e => {
    const diff = e.deltaY || e.deltaX;
    spanRef.current.scrollLeft += diff * 0.5;
    e.preventDefault();
  };
  useEffect(() => {
    spanRef.current.addEventListener('wheel', wheelHandler, {
      passive: false
    });
  });
  return <span className="py-2 mt-2 flex flex-row flex-nowrap space-x-4 md:overflow-x-hidden overflow-x-auto cursor-grab touch-pan-x" ref={spanRef} onMouseDown={mouseDownHandler} onClickCapture={e => {
    if (e.clientX != pos.x || e.clientY != pos.y) {
      e.stopPropagation();
    }
  }}>
      {children}
    </span>;
}
_s(ScrollableContainer, "ObitFCsn35YeSWXF2LU6H3MsDF8=");
_c = ScrollableContainer;
var _c;
$RefreshReg$(_c, "ScrollableContainer");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;